import React, { Component } from 'react';

import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { authenticationService } from '_services';

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  //Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col
} from "reactstrap";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import TransparentFooter from "components/Footers/TransparentFooter.js";

class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            firstFocus: '',
            lastFocus: '',
            isValid: false,
            counter: 0,
        };
    }

    componentDidMount() {
        document.body.classList.add("login-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

        return function cleanup() {
            document.body.classList.remove("login-page");
            document.body.classList.remove("sidebar-collapse");
        };
    }

    componentDidUpdate() {
        document.body.classList.add("login-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;

        return function cleanup() {
            document.body.classList.remove("login-page");
            document.body.classList.remove("sidebar-collapse");
        };
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

render() {    
  return (
    <>
      <ExamplesNavbar />
      <div className="page-header clear-filter" filter-color="blue">
        <div
          className="page-header-image"
          style={{
            backgroundImage: "url(" + require("assets/img/login.jpg") + ")"
          }}
        ></div>


        <div className="content">
          <Container>
            <Col className="ml-auto mr-auto" md="4">
                 
                    <Formik
                                      initialValues={{
                                          username: '',
                                          password: ''
                                      }}
                                      validationSchema={Yup.object().shape({
                                          username: Yup.string().required('Username is required'),
                                          password: Yup.string().required('Password is required')
                                      })}
                                      onSubmit={({ username, password }, { setStatus, setSubmitting }) => {
                                          setStatus();
                                          authenticationService.login(username, password)
                                              .then(
                                                  user => {

                                                      const { from } = this.props.location.state || { from: { pathname: (user.role !== undefined && user.role != null) ? (user.role.substring(0, 2) != 'N_') ? "/admin" :"/hospital" : "/home" } };

                                                      this.props.history.push(from);
                                                  },
                                                  error => {
                                                      setSubmitting(false);
                                                      console.log(error);
                                                      //setStatus(error);
                                                  }
                                              );
                                      }}
                                      render={({ errors, status, touched, isSubmitting }) => (

                                          <Card className="card-login card-plain">
                                            <Form>
                                              <CardHeader className="text-center">
                                                  <div className="">
                                                          <img
                                                                  alt="..."
                                                                  src={require("assets/img/logo1.png")}
                                                              ></img>
                                                      
                                                  </div>
                                              </CardHeader>
                                              <CardBody>
                                                  
                                                      <InputGroup
                                                          className={
                                                              "no-border input-lg" +
                                                              (this.state.firstFocus ? " input-group-focus" : "")
                                                          }
                                                      >
                                                          <InputGroupAddon addonType="prepend">
                                                              <InputGroupText>
                                                                  <i className="now-ui-icons users_circle-08"></i>
                                                              </InputGroupText>
                                                          </InputGroupAddon>

                                                          <Field
                                                              placeholder="Email หรือ เลขบัตรประชาชน"
                                                              name="username"
                                                              type="text"
                                                              className={'form-control' + (errors.username && touched.username ? ' is-invalid' : '')}
                                                          />
                                                          <ErrorMessage name="username" component="div" className="invalid-feedback" />
                                                      </InputGroup>


                                                      <InputGroup
                                                          className={
                                                              "no-border input-lg" +
                                                              (this.state.firstFocus ? " input-group-focus" : "")
                                                          }
                                                      >
                                                          <InputGroupAddon addonType="prepend">
                                                              <InputGroupText>
                                                                  <i className="now-ui-icons text_caps-small"></i>
                                                              </InputGroupText>
                                                          </InputGroupAddon>

                                                          <Field
                                                              placeholder="รหัสผ่าน"
                                                              name="password"
                                                              type="password"
                                                              className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')}
                                                          />
                                                          <ErrorMessage name="password" component="div" className="invalid-feedback" />
                                                      </InputGroup>

          
                                                      {status &&
                                                          <div className={'alert alert-danger'}>{status}</div>
                                                      }
                                                  
                                              </CardBody>
                                              <CardFooter className="text-center">
                                                      <div className="form-group">
              
                                                          <Button
                                                              type="submit"
                                                              block
                                                              className="btn-round"
                                                              color="info"
                                                              disabled={isSubmitting}
                                                              size="lg"
                                                          >
                                                              เข้าสู่ระบบ
                                                          </Button>
                                                      {isSubmitting &&
                                                          <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                                      }
                                                  </div>
                                                  {status &&
                                                      <div className={'alert alert-danger'}>{status}</div>
                                                  }
 
                                                  <div className="pull-left">
                                                      <h6>
                                                          <a
                                                              className="link"
                                                              href="/register"
                                                           
                                                          >
                                                             
                            </a>
                                                      </h6>
                                                  </div>
                                                  <div className="pull-right">
                                                      <h6>
                                                          <a
                                                              className="link"
                                                              href=""
                                                              onClick={e => e.preventDefault()}
                                                          >
                                                                
                            </a>
                                                      </h6>
                                                  </div>
                                                  </CardFooter>
                                            </Form>
                                          </Card> 



                                      )}
                                  /> 



              
            </Col>
          </Container>
        </div>
        <TransparentFooter />
      </div>
    </>
  );
 }
}


export default LoginPage;
